module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA6BAMAAAAeiydcAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTP/IXP/MWv/JXP/IXf/JXP/HW//IXP/KXf/HXf/JXboBzScAAAAKdFJOUwB/Hb+f6jlZz3ARRGyeAAAAyElEQVQ4y2NgoApILECw2cTRZRlXrURwpFZNQJNmXbUUwYlaFYAmzbVqFYKzatWCwSCtvAoPaGLowie9mGEVXjCcpRfgSkBco9JwoKSEV1pqlQIOaUZjAzzSTFYgJk7p1FX4pNmj8Ep7rVqKR5pl1dISPNJsUWEsUGm2MiyGVyhApTWjVgViSjMxQKW9gGlMAEuwQKWjgqNWLcMtvRDIWIJb2oGBCZ90ArDkWoxbGujvLvzSVsNLml0QGBOJgkDpQnFq5RLalUwAhSPV0fDXIqYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notification/booking_reminder.png
// module id = 1814
// module chunks = 0